import type * as React from 'react';

import type * as api from '@gitbook/api-client';
import type { NavigationScreenSpaceState } from '@gitbook/app-navigation';
import { Icon } from '@gitbook/spine-icons';
import {
    Button,
    Description,
    EmptyState,
    EmptyStateAccessDeniedHeader,
    EmptyStateActions,
} from '@gitbook/spine-react';

/**
 * Full-screen component when the user can't access a space.
 */
export function SpaceNotAuthorized(props: {
    space?: api.Space;
    screen: NavigationScreenSpaceState;
}): React.ReactElement {
    const { space, screen } = props;

    return (
        <EmptyState>
            <EmptyStateAccessDeniedHeader />
            <Description>
                You don't have permissions to access this space. Contact the organization
                administrator to configure access.
            </Description>
            <EmptyStateActions>
                {space?.urls.public ? (
                    <Button
                        label="Open public URL"
                        testID="space.unauthorized.openPublicButton"
                        kind="secondary"
                        leadingIcon={Icon.ExternalLink}
                        href={`${space.urls.public}/${screen.page}`}
                    />
                ) : (
                    <Button
                        kind="secondary"
                        size="medium"
                        href={{ screen: { type: 'home' } }}
                        label="Back"
                    />
                )}
            </EmptyStateActions>
        </EmptyState>
    );
}
